module.exports = __webpack_public_path__ + "static/media/2 pokemon starmie color tattoo galaxy anime gaming tattoo cardgame.1280x960.18e95845.webp";